import React, { useEffect, useRef, useState } from "react";
import styles from "./DealerPipeline.module.scss";

/**
 * A "More" button for a panel's less used actions. Closes on a pick, a click
 * outside, or Escape (which then doesn't also close the panel).
 *
 * Props: items - [{ label, onClick } | { label, href }], falsy entries skipped;
 * disabled
 */
const MoreMenu = ({ items, disabled }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);

  const shown = items.filter(Boolean);
  if (!shown.length) return null;

  const onKeyDown = (e) => {
    if (e.key === "Escape" && open) {
      e.stopPropagation();
      setOpen(false);
    }
  };

  return (
    <div className={styles.moreMenu} ref={ref} onKeyDown={onKeyDown}>
      <button
        type="button"
        className={styles.btn}
        aria-haspopup="menu"
        aria-expanded={open}
        disabled={disabled}
        onClick={() => setOpen((o) => !o)}
      >
        More ▾
      </button>
      {open && (
        <div className={styles.moreMenuList} role="menu">
          {shown.map((item) => (item.href ? (
            <a key={item.label} role="menuitem" href={item.href} onClick={() => setOpen(false)}>{item.label}</a>
          ) : (
            <button
              key={item.label}
              type="button"
              role="menuitem"
              title={item.title}
              onClick={() => {
                setOpen(false);
                item.onClick();
              }}
            >
              {item.label}
            </button>
          )))}
        </div>
      )}
    </div>
  );
};

export default MoreMenu;
